import type { FC } from 'react'
import { SvgIconProps } from '@mui/material'

import { InfoColored } from './InfoColored.js'

export const InfoYellow: FC<SvgIconProps> = (props) => (
  <InfoColored circleFillColor="#FC0" letterFillColor="#333" {...props} />
)
